export const environment = {
  production: false,
  enableDebug: false,
  url_api: "https://app-z3gjk55rwa-uc.a.run.app",
  mapa_key: "",
  token_core: "",
  tarjeta_key: "https://app-z3gjk55rwa-uc.a.run.app/api/web",
  sandbox_api_key: "",
  config_firebase: {
    apiKey: "AIzaSyD3U8f7LuG7nmTQAKSvd4WuuOskGt7DhGA",
    authDomain: "cocoa-test-f6f5d.firebaseapp.com",
    databaseURL: "https://cocoa-test-f6f5d-default-rtdb.firebaseio.com",
    projectId: "cocoa-test-f6f5d",
    storageBucket: "cocoa-test-f6f5d.appspot.com",
    messagingSenderId: "113324903193",
    appId: "1:113324903193:web:5d871523ced1cd2b421388",
    measurementId: "G-CDG0ZDJJGD"
  },
  DeviceDataColection: "",
  wallet: "10009",
  fcm_vapid_key: "",
  codigo_validacion_canje: "123456",
  tinymce_api_key: "",
  features: {
    usePagoConTokenOrquestado: true
  }
};
